export const ROOT_URL = 'http://www.horfex.at'
export const TOKEN = '26ea913e3381eeca2266935ae054ee'



// WEBPACK FOOTER //
// ./src/config/index.js